export default "__VITE_ASSET__CL8FxH63__"